import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfCustomerIconProps extends SvgIconProps {}
/**
 * component used to display customer icon in customer history card
 * @param props - CcfCustomerIcon
 * @example - <CcfCustomerIcon />
 * @returns SVG of customer icon 
 */
export function CcfCustomerIcon(props: CcfCustomerIconProps) {
  return (
    <SvgIcon viewBox="0 0 14.549 20" {...props}>
      <g clip-path="url(#clip0_1734_19501)">
        <path
          d="M5.99961 1.2C6.74642 1.2 7.43578 1.5 7.89535 2.04C8.35493 2.58 8.64216 3.3 8.64216 4.02C8.64216 4.56 8.52727 5.1 8.24003 5.52C8.12514 5.64 8.06769 5.82 7.9528 5.94L7.03365 7.02L8.18259 7.74C8.58472 7.98 8.98684 8.34 9.33152 8.82C9.7911 9.48 10.1358 10.2 10.1932 10.8H1.57621C1.63365 10.2 2.09323 9.42 2.5528 8.82C2.89748 8.4 3.24216 8.04 3.70174 7.74L4.85067 7.02L3.98897 5.94C3.87408 5.82 3.81663 5.7 3.70174 5.58C3.47195 5.1 3.29961 4.56 3.29961 4.02C3.29961 3.3 3.58684 2.58 4.04642 2.04C4.56344 1.5 5.2528 1.2 5.99961 1.2ZM5.99961 0C4.90812 0 3.98897 0.42 3.24216 1.2C2.5528 1.98 2.15067 3 2.15067 4.02C2.15067 4.8 2.32301 5.52 2.72514 6.18C2.84003 6.36 2.95493 6.54 3.12727 6.72C2.61025 7.08 2.09323 7.5 1.6911 8.04C1.00174 8.94 0.599609 10.08 0.599609 10.98C0.599609 11.58 1.05918 12 1.6911 12H10.3081C10.8826 12 11.3996 11.52 11.3996 10.98C11.3996 10.08 10.9975 9 10.3081 8.1C9.90599 7.56 9.38897 7.08 8.87195 6.78C8.98684 6.6 9.15918 6.42 9.27408 6.24C9.6762 5.58 9.84855 4.86 9.84855 4.08C9.7911 3 9.38897 1.98 8.69961 1.2C8.01025 0.42 7.03365 0 5.99961 0V0Z"
          fill="#526B7A"
        />
      </g>
      <defs>
        <clipPath id="clip0_1734_19501">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default CcfCustomerIcon;
